export default {
    externals: [

      {   title: 'API Enterprise Router',
          description: 'Extend, Control, Monitore and Analyse your accessebility to third party SDK with less hassle.',
          percent: .7,
          status: 'deep-orange-5',
          color: 'bg-light-blue-2',
          image: 'https://gkiokan.net/modules/web/img/aer2.png',
          for: ['SaaS', 'Proxy', 'External Service', 'API', 'Third-Party-API']
      },

      {   title: 'YouTube Manager | YTM',
          description: 'Multimedia Platform based on YouTube. Stream, View, Select, Set, Catch and consume your favorite YouTube Videos like on netflix and co.',
          percent: 1,
          status: 'lime-14',
          color: 'bg-purple-2',
          image: 'https://gkiokan.net/modules/web/img/share2-min.png',
          for: ['SaaS', 'YTM', 'Module']
      },

      {   title: 'YouTube Catcher | YTM',
          description: 'Catch your favorite YouTube Thumbnails and Videos',
          percent: 0.9,
          status: 'positive',
          color: 'bg-yellow-2',
          image: 'https://gkiokan.net/modules/web/img/ytc4-min.png',
          for: ['SaaS', 'YTM', 'Gallery', 'Images', 'Module']
      },

      {   title: 'KanaX | YTM',
          description: 'A new source of streaming. A mix between Netflix, YouTube, Spotify and Deezer.',
          percent: 0.6,
          status: 'pink-13',
          color: 'bg-pink-2',
          image: 'https://gkiokan.net/modules/web/img/EpisodePreviews-custom-min.png',
          for: ['SaaS', 'Netflix', 'YouTube', 'Spotify', 'Deezer', 'Module']
      },


      {   title: 'License Manager',
          description: 'License your External Plugins and Themes or anything you want. Create Serials with lifetime and keep them all under the hood.',
          percent: 0,
          status: 'warning',
          color: 'bg-red-2',
          for: ['SaaS', 'API']
      },

      {   title: 'WordPress Enterprise Solutions',
          description: 'WordPress Enterprise Products as development and release candidates. Exclusive Themes and Plugins.',
          percent: 0,
          status: 'light-blue',
          color: 'bg-teal-2',
          for: ['SaaS', 'WordPress', 'Plugins', 'Themes', 'API']
      },

      {   title: 'WordPress App Store',
          description: 'Your own custom WordPress App Store. Setup Customer UID Keys and get auto installed all nessesary pre selected Plugins and Themes with their configuration.',
          percent: 0,
          status: 'light-blue',
          color: 'bg-orange-2',
          for: ['SaaS', 'WordPress', 'Enterprise', 'Dashboard', 'API']
      },

      {
          title: 'Blog',
          description: 'Content from here and there. Posts of different stuff and categories. ',
          percent: 0,
          status: 'red',
          color: 'bg-teal-2',
          for: ['SaaS', 'Module']
      },

    ],

    internals: [
      {   title: 'Upcomming Projects',
          description: '',
          percent: '0%',
          for: [] },

      {   title: 'Integrating with external Platforms',
          description: '',
          percent: '0%',
          for: [] },

      {   title: 'Blog, Scripts & Tools',
          description: '',
          percent: '0%',
          for: [] },

      {   title: 'The good old Gallery & Forum',
          description: '',
          percent: '0%',
          for: [] },

      {   title: 'SaaS Application',
          description: '',
          percent: '0%',
          for: [] },

      {   title: 'Multistructured Modulary Applications',
          description: '',
          percent: '0%',
          for: [] },
    ]
}
